export default {
  pageTitle: '腐食科学と防食セミナー',
  metaDescription: 'PT Tokki Engineering and Fabrication（TEF）を、貴社での「Corrosion Science and Prevention」セミナー講師としてご招待いただけます。',
  hero: {
    eyebrow: 'TOKKI（TEF）腐食セミナー',
    titleGreen: '腐食科学と',
    titleBlack: '防食対策',
    subtitleLine1: '実践的な知識。確かな解決策。',
    subtitleLine2: 'より安全で信頼できる明日へ。',
    description: 'エンジニアリング、材料選定、溶接、修繕、メンテナンスにおけるTOKKI（TEF）の経験に基づく知見で、貴社の産業設備の安全性・信頼性・耐用年数を向上させます。',
    registerBtn: 'セミナーを申し込む',
    learnMoreBtn: '詳しく見る',
    badgeSmall: 'Your Corrosion Doctor',
    badgeTagline1: '信頼できる設備',
    badgeTagline2: 'より強い産業',
    badgeTagline3: 'より明るいインドネシア',
  },
  about: {
    eyebrow: 'セミナーについて',
    heading: '学べる内容',
    intro: '本セミナーでは、TOKKI（TEF）の現場経験に基づき、重要なトピックを分かりやすく実践的に解説します。',
    topics: {
      t1: { title: '腐食が発生する仕組みと原因', desc: '' },
      t2: { title: '金属ごとの特性と腐食挙動の違い', desc: '' },
      t3: { title: '腐食の種類', desc: '（全面腐食、孔食、隙間腐食、応力腐食割れ）' },
      t4: { title: '材料選定', desc: '流体の種類・温度・圧力・濃度に基づく選定' },
      t5: { title: '腐食防止の方法（検査・監視・メンテナンスを含む）', desc: '' },
      t6: { title: '実際の事例と解決策', desc: '熱交換器、圧力容器、配管などにおける実際の事例を含む' },
    },
    customizationNote: 'セミナー内容は、貴社の業種、設備、稼働条件、具体的な腐食に関する懸念に応じてカスタマイズ可能です。',
  },
  locations: {
    eyebrow: 'セミナー会場',
    heading: 'セミナー会場',
    description: 'セミナーは以下いずれかの会場で開催可能です：',
    clientSite: { title: 'お客様の工場または施設にて' },
    tefOffice: { title: 'TOKKI（TEF）工場にて' },
  },
  audience: {
    eyebrow: 'こんな方におすすめです',
    heading: 'こんな方におすすめです',
    roles: [
      'プラントマネージャー',
      'メンテナンス・設備担当者',
      'エンジニア',
      '検査・QA/QC担当者',
      '生産・運転チーム',
      '調達担当者',
      '若手エンジニア',
    ],
  },
  process: {
    eyebrow: '修理から保護へ',
    headingLine1: '「故障後の修理」から',
    headingLine2: '「故障前の保護」へ',
    description: '腐食管理とは、設備が故障した後に修理することだけではありません。各段階で腐食リスクを正しく管理し、早期に行動することが重要です。',
    steps: ['設計', '材料選定', '製作', '溶接', '検査', '運転', 'メンテナンス'],
  },
  commitment: {
    eyebrow: '私たちの約束',
    heading: '私たちの約束',
    description: 'TOKKI（TEF）は、実践的な経験と豊富な現場実績を活かし、お客様の大切な産業設備を守ります。',
    tagline: 'Masa Depan <b>INDONESIA</b>,<br>Dengan Teknologi <b>INDONESIA</b>.',
    subtagline: 'インドネシアの技術で、<br>インドネシアの未来を。',
  },
  contact: {
    eyebrow: 'ご質問はありますか？',
    heading: 'ご質問はありますか？',
    description: '「Corrosion Science and Prevention」セミナーに関する詳細は、TOKKI（TEF）ビジネス開発チームまでお問い合わせください。',
    button: '担当チームに問い合わせる',
    tagline: '共に、より安全で持続可能な産業を築いていきましょう。',
  },
  form: {
    heading: 'Register for the Seminar',
    subheading: '以下のフォームにご入力ください。担当者より詳細をご連絡いたします',
    fullName: 'お名前',
    fullNamePlaceholder: 'お名前をご入力ください',
    companyName: '会社名',
    companyNamePlaceholder: '会社名をご入力ください',
    jobTitle: '役職',
    jobTitlePlaceholder: '役職をご入力ください',
    industry: '業種',
    industryPlaceholder: '業種を選択してください',
    industries: ['石油・ガス', '石油化学', '製薬', '肥料', '発電', 'その他'],
    email: 'メールアドレス',
    emailPlaceholder: 'メールアドレスをご入力ください',
    phoneNumber: '電話番号',
    phoneNumberPlaceholder: '電話番号をご入力ください',
    preferredDate: 'ご希望日',
    participants: '参加予定人数',
    participantsPlaceholder: '参加人数',
    location: 'セミナー会場',
    locationPlaceholder: '会場を選択してください',
    locationClientSite: '貴社会場にて',
    locationTefOffice: 'TEF施設にて',
    message: 'メッセージ・ご関心分野',
    messagePlaceholder: 'ご質問やご要望をお聞かせください（任意）',
    submit: 'Submit Registration',
    pleaseWait: '送信中...',
    successMessage: 'セミナー招待のお申し込みを受け付けました。担当者より近日中にご連絡いたします。',
    errorMessage: '送信に失敗しました。もう一度お試しください。',
    requiredNotice: '* の付いた項目は必須です',
    confidentialNotice: 'ご入力いただいた情報は厳重に管理いたします',
  },
};
